import React from 'react'
import { SvgBottom } from './svg/SvgBottom'
import { SvgTop } from './svg/SvgTop'

export const Leasing = () => {
  return (
    <section className="leasing_main" id="leasing">
      <div className="leasing_container">

        <SvgTop />

        <article className="caja_blanca">

          <div className="leasing_text">
            <h1>Conoce el leasing <span>habitacional</span></h1>
          </div>

          <div className="leasing_content">
            <section>
              <article className="leasing_paragraf">
                <p><span>¡A los colombianos nos encanta ayudar a nuestras familias!</span> Mes a mes enviamos remesas a Colombia para que paguen gastos como el arriendo. <span>¿Pero sabías que esa plata la puedes usar para construir un patrimonio?</span>
                </p>

                <p>El Leasing habitacional te sirve para invertir en una casa en Colombia. Con el dinero que envías puedes comprar un inmueble en el que podría vivir tu familia. <span>¡Así los sigues ayudando mientras te beneficias con la inversión!</span></p>

              </article>

              <div className="leasing_list">
                <ul>
                  <li>Financia hasta el 80% del inmueble </li>
                  <li>Aplica para VIS y No VIS</li>
                </ul>
              </div>

              <div className='leasing-derechos'>
                <ul>
                  <li>Productos sujetos a políticas y condiciones de evaluación, aprobación y desembolso del Banco Davivienda S.A.</li>
                  <li>La tasa de interés es aplicable al momento del desembolso Consulte más información sobre productos, servicios, tasas y tarifas en <a href="www.davivienda.com">www.davivienda.com</a> </li>
                </ul>
              </div>
            </section>
          </div>

        </article>
        <SvgBottom />
      </div>
    </section>
  )
}
